export default __webpack_public_path__ + "assets/images/1.2e5011.png";